export default "__VITE_ASSET__b0xGv_us__"